export enum ListingCreateStatus {
  SOLD = "sold",
  PUBLISHED = "published",
  DEACTIVATED = "deactivated",
}
